<template>
  <div>
    <v-app-bar color="rojoDycar" style="z-index: 2" :flat="$vuetify.breakpoint.mdAndUp" dense dark app>
    <v-app-bar-nav-icon
      @click.stop="$vuetify.breakpoint.smAndDown ? drawer = !drawer : expand = !expand"></v-app-bar-nav-icon>
    <!-- Obtiene el nombre del menu -->
    <span class="app-bar-titulo" :title="titulo_completo">{{ titulo }}</span>
    <!-- boton para el tema (solo desktop) -->
    <v-btn v-if="!es_mobile" :title="$vuetify.theme.dark ? 'Tema claro' : 'Tema oscuro'" :loading="load" icon @click="set_theme()">
      <v-icon>
        fas fa-{{ $vuetify.theme.dark ? 'sun' : 'moon' }}
      </v-icon>
    </v-btn>

    <!-- menú de notificaciones -->

    <v-menu max-width="300" transition="scale-transition"
      :origin="$vuetify.breakpoint.smAndDown ? 'center top' : 'right top'" :nudge-width="250"
      :nudge-left="$vuetify.breakpoint.smAndDown ? 0 : 250" :disabled="$route.name === 'Notificaciones'"
      :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" title="Notificaciones" :disabled="$route.name === 'Notificaciones'" icon>
          <v-badge :content="$store.state.notificaciones.length" :value="$store.state.notificaciones.length"
            color="error" overlap>
            <v-icon>fas fa-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>
      <ModalNotificaciones />
    </v-menu>
    <!-- resolución de tickets (solo desktop) -->
    <v-btn v-if="es_dba && !es_mobile" title="Resolución de tickets" icon to="/mesa-tickets"
      :disabled="$route.path === '/mesa-tickets'">
      <v-icon>fas fa-clipboard-check</v-icon>
    </v-btn>
    <!-- botón volver al usuario original (visible al impersonar) -->
    <v-btn v-if="$store.state.isImpersonating" text small class="mr-2"
      @click="dejarDeUsar()">
      <v-icon left small>fas fa-undo</v-icon>
      Volver
    </v-btn>
    <!-- menu de usuario (solo desktop) -->
    <v-menu v-if="!es_mobile" offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon>fas fa-user-cog</v-icon>
        </v-btn>
      </template>
      <v-list class="py-2">
        <v-list-item class="my-n1" style="cursor: pointer" @click.stop="dialog_clave = true">
          <v-list-item-title>
            <v-icon left small>fas fa-key</v-icon>
            Cambiar clave
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="$store.state.usuario.cambiaPin === 1" class="my-n1" style="cursor: pointer"
          @click.stop="dialog_pin = true">
          <v-list-item-title>
            <v-icon left small>fas fa-ellipsis-h</v-icon>
            Cambiar PIN
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!$store.state.isImpersonating" class="my-n1" style="cursor: pointer"
          @click.stop="dialog_impersonate = true">
          <v-list-item-title>
            <v-icon left small>fas fa-user-friends</v-icon>
            Usar como
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-else class="my-n1" style="cursor: pointer" @click.stop="dejarDeUsar()">
          <v-list-item-title>
            <v-icon left small>fas fa-undo</v-icon>
            Dejar de usar
          </v-list-item-title>
        </v-list-item>
        <v-list-item class="my-n1" style="cursor: pointer" @click.stop="sincronizar()">
          <v-list-item-title>
            <v-icon left small>fas fa-sync</v-icon>
            Sincronizar
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- nombre de usuario (solo desktop) -->
    <div v-if="!es_mobile" class="d-flex align-center font-weight-medium px-2"
      style="font-size: 14px; letter-spacing: 1.374px; cursor: default;">
      <v-avatar size="36">
        <v-icon>fas fa-user-circle</v-icon>
      </v-avatar>
      <div class="ml-2">{{ $store.state.username }}</div>
    </div>
    <!-- logout (solo desktop) -->
    <v-tooltip v-if="!es_mobile" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon @click="logout()">
          <v-icon>fas fa-sign-out-alt</v-icon>
        </v-btn>
      </template>
      <span>Cerrar sesión</span>
    </v-tooltip>
    <!-- menú de contexto (solo mobile) -->
    <v-menu v-if="es_mobile" offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" title="Más opciones" icon>
          <v-icon>fas fa-ellipsis-v</v-icon>
        </v-btn>
      </template>
      <v-list class="py-2">
        <v-list-item class="my-n1" style="cursor: pointer" @click.stop="set_theme()">
          <v-list-item-title>
            <v-icon left small>fas fa-{{ $vuetify.theme.dark ? 'sun' : 'moon' }}</v-icon>
            {{ $vuetify.theme.dark ? 'Tema claro' : 'Tema oscuro' }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="es_dba" class="my-n1" :disabled="$route.path === '/mesa-tickets'" style="cursor: pointer"
          @click.stop="$router.push('/mesa-tickets')">
          <v-list-item-title>
            <v-icon left small>fas fa-clipboard-check</v-icon>
            Resolución de tickets
          </v-list-item-title>
        </v-list-item>
        <v-divider class="my-1"></v-divider>
        <v-list-item class="my-n1" style="cursor: pointer" @click.stop="dialog_clave = true">
          <v-list-item-title>
            <v-icon left small>fas fa-key</v-icon>
            Cambiar clave
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="$store.state.usuario.cambiaPin === 1" class="my-n1" style="cursor: pointer"
          @click.stop="dialog_pin = true">
          <v-list-item-title>
            <v-icon left small>fas fa-ellipsis-h</v-icon>
            Cambiar PIN
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!$store.state.isImpersonating" class="my-n1" style="cursor: pointer"
          @click.stop="dialog_impersonate = true">
          <v-list-item-title>
            <v-icon left small>fas fa-user-friends</v-icon>
            Usar como
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-else class="my-n1" style="cursor: pointer" @click.stop="dejarDeUsar()">
          <v-list-item-title>
            <v-icon left small>fas fa-undo</v-icon>
            Dejar de usar
          </v-list-item-title>
        </v-list-item>
        <v-list-item class="my-n1" style="cursor: pointer" @click.stop="sincronizar()">
          <v-list-item-title>
            <v-icon left small>fas fa-sync</v-icon>
            Sincronizar
          </v-list-item-title>
        </v-list-item>
        <v-divider class="my-1"></v-divider>
        <v-list-item class="my-n1" style="cursor: pointer" @click.stop="logout()">
          <v-list-item-title>
            <v-icon left small>fas fa-sign-out-alt</v-icon>
            Cerrar sesión
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <CambiarClave v-model="dialog_clave" />
    <CambiarPIN v-model="dialog_pin" />
    <CambiarUsuario v-model="dialog_impersonate" />
  </v-app-bar>
  </div>
</template>

<script>
import CambiarClave from './components/CambiarClave'
import CambiarPIN from './components/CambiarPIN'
import CambiarUsuario from './components/CambiarUsuario'
import ModalNotificaciones from './components/ModalNotificaciones'
import store from './store'

export default {
  data() {
    return {
      dialog_clave: false,
      dialog_pin: false,
      dialog_impersonate: false,
      load: false,
      es_dba: false
    }
  },
  async created() {
    this.$vuetify.theme.dark = JSON.parse(localStorage.getItem('dark'))

    await this.$store.dispatch('roles/getRolesDelUsuario').then(res => {
      if (res.exito) {
        this.es_dba = res.data.some(rol => rol.Rol_id === 1)
      } else {
        this.$store.dispatch('show_snackbar', {
          text: res.message,
          color: 'error'
        })
      }
    })

  },
  props: {
    p_expand: Boolean,
    p_drawer: Boolean
  },
  components: {
    CambiarClave,
    CambiarPIN,
    CambiarUsuario,
    ModalNotificaciones
  },
  computed: {
    expand: {
      get() {
        return this.p_expand
      },
      set(value) {
        this.$emit('update:p_expand', value)
      }
    },
    drawer: {
      get() {
        return this.p_drawer
      },
      set(value) {
        this.$emit('update:p_drawer', value)
      }
    },
    es_mobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    // Título completo: nombre del menú para la ruta actual o, si no hay, el nombre de la ruta
    titulo_completo() {
      const nombres = this.$store.state.menu_nombres || []
      const item = nombres.find(item => item.ruta == this.$route.path)
      return (item ? item.nombre : this.$route.name) || ''
    },
    // Si el título supera los 40 caracteres se muestra truncado con "..."
    titulo() {
      return this.titulo_completo.length > 40
        ? this.titulo_completo.substring(0, 40) + '...'
        : this.titulo_completo
    }
  },
  methods: {
    async sincronizar() {
      this.$store.state.loading = true
      await this.$store.dispatch('get_user_data')
        .then(() => {
          this.$store.dispatch('show_snackbar', {
            text: 'Sincronización de perfil exitosa',
            color: 'success'
          })
          window.location.reload(true)
        })
        .catch((error) => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error'
          })
        })
      this.$store.state.loading = false
    },
    async set_theme() {
      this.load = true
      await this.$store.dispatch('set_theme', !this.$vuetify.theme.dark)
        .then((res) => {
          this.$vuetify.theme.dark = !this.$vuetify.theme.dark
          this.$store.dispatch('show_snackbar', {
            text: 'Tema cambiado correcamente',
            color: 'success'
          })
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error'
          })
        })
      this.load = false
    },
    async logout() {
      await this.$store.dispatch('logout')
        .then(async () => {
          await this.$router.push({ path: "/login" })
        })
        .catch(error => {
          dispatch('show_snackbar', {
            color: 'error',
            text: error.message
          })
        })
      this.$vuetify.theme.dark = false
    },
    async dejarDeUsar() {
      this.$store.state.loading = true
      await this.$store.dispatch('stopImpersonating')
        .then(() => {
          this.$store.dispatch('show_snackbar', {
            text: 'Sesión restaurada correctamente',
            color: 'success'
          })
          window.location.reload(true)
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message || 'Error al dejar de usar',
            color: 'error'
          })
        })
      this.$store.state.loading = false
    }
  }
}
</script>

<style scoped>
.app-bar-titulo {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
}
</style>
